import { useState } from 'react';
import { Col, Form, Radio, Space, Select, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import DownOutlinedMobile from '../../../../assets/icons/DownOutlinedMobile.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { ProvinceSelector } from 'afrodita';

const { Option } = Select;
const { Text } = Typography;

const TaxCalculationForm2 = ({ edit, form, userToken, axios, env }) => {
	const { t } = useTranslation();
	const colSpan = {
		xxl: edit === undefined ? 24 : 6,
		xl: edit === undefined ? 24 : 6,
		lg: edit === undefined ? 24 : 8,
		md: edit === undefined ? 24 : 12,
		sm: 24,
		xs: 24
	};

	const [modalAndalucia, setModalAndalucia] = useState(false);
	const params = useParams();
	const navigate = useNavigate();

	const onChangeProvince = (event) => {
		if (
			event === 'Almería' ||
			event === 'Granada' ||
			event === 'Málaga' ||
			event === 'Jaén' ||
			event === 'Córdoba' ||
			event === 'Sevilla' ||
			event === 'Cádiz' ||
			event === 'Huelva'
		) {
			setModalAndalucia(true);
		}
	};

	const backTop = () => {
		setModalAndalucia(false);
		form.setFieldsValue({ province: 'Madrid' });
	};

	const closeOperation = () => {
		axios
			.post(
				`${env.api.url}/v1/operations/operation-close`,
				{
					operationId: params.operationId,
					applicant: 'Gibobs',
					closeReason: 'B. Sabadell - Compra en Andalucía',
					subCloseReason: 'B. Sabadell - Compra en Andalucía',
					body: 'B. Sabadell - Compra en Andalucía',
					closeAllTask: true
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				setModalAndalucia(false);
				navigate('/welcomeSelection');
				window.open('https://newsletters.bancsabadell.com/hipotecas', '_blank');
			});
	};

	return (
		<>
			<Col {...colSpan}>
				<Form.Item name="province" label={t('viability.provinceViability')}>
					<ProvinceSelector
						id="province"
						placeholder={t('form.province')}
						style={{ width: '100%' }}
						onChange={(e) => onChangeProvince(e)} />
				</Form.Item>
			</Col>
			{edit !== undefined && (
				<Col {...colSpan}>
					<Form.Item name="propertyType" label={t('form.propertyType')}>
						<Select
							id="propertyType"
							suffixIcon={<img src={DownOutlinedMobile} alt="DownOutlinedMobile" />}
							placeholder={t('form.select')}
							style={{ width: '100%' }}>
							<Option value="newConstruction">{t('form.newBuild')}</Option>
							<Option value="secondHand">{t('form.secondHand')}</Option>
						</Select>
					</Form.Item>
				</Col>
			)}
			{edit === undefined && (
				<Col span={24}>
					<Form.Item name="propertyType" label={t('form.propertyType')}>
						<Radio.Group id="propertyType">
							<Space direction="vertical">
								<Radio value="newConstruction">{t('form.newBuild')}</Radio>
								<Radio value="secondHand">{t('form.secondHand')}</Radio>
							</Space>
						</Radio.Group>
					</Form.Item>
				</Col>
			)}

			<Modal
				className="ModalCommon"
				open={modalAndalucia}
				title={t('andaluciaModal.title')}
				width={480}
				closable={true}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: { width: '46%', height: 40, fontSize: 14 }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: '46%', height: 40, fontSize: 14 }
				}}
				onCancel={() => backTop()}
				onOk={() => closeOperation()}
				centered>
				<div style={{ marginBottom: 0, marginTop: -20 }}>
					<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
						{t('andaluciaModal.text')}
					</Text>
				</div>
			</Modal>
		</>
	);
};

export default TaxCalculationForm2;
